import styled from 'styled-components';

export const NoticeCompanyListWrapper = styled.div`
  width: 93.75rem;
  margin-top: 2.5rem;
  margin: 2.5rem auto 0 auto;
`;
